module.exports = __webpack_public_path__ + "img/HeimwehScreenshot17.12eb3e66.png";